import { create } from "zustand";
import User from "../interfaces/user";

export type OrdinationStore = {
  page: number;
  name: string;
  pageSize: number;
  currentOrder: "asc" | "desc";
  fieldOrder: string;

  setPage: (page: number) => void;
  setName: (name: string) => void;
  setCurrentOrder: (order: "asc" | "desc") => void;
  setFieldOrder: (field: string) => void;
  resetOrdination: () => void;
};

const useOrdinationStore = create<OrdinationStore>((set: any) => ({
  page: 0,
  name: "",
  pageSize: 25,
  currentOrder: "asc",
  fieldOrder: "id",

  setPage: (page: number) => set(() => ({ page })),
  setName: (name: string) => set(() => ({ name })),
  setSelectedUser: (selectedUser: User) => {
    set(() => ({ selectedUser }));
  },
  setCurrentOrder: (currentOrder: "asc" | "desc") =>
    set(() => ({ currentOrder })),
  setFieldOrder: (fieldOrder: string) =>
    set(() => ({ fieldOrder, currentOrder: "asc" })),
  resetOrdination: () => {
    set(() => ({
      page: 0,
      name: "",
      selectedUser: {} as User,
      pageSize: 25,
      currentOrder: "asc",
      fieldOrder: "id",
    }));
  },
}));

export default useOrdinationStore;
